/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import tinymce from 'tinymce';
import { path } from 'rich-text-lib/utils/iterables';
import { LocalStoreHandlers } from 'rich-text-lib/utils/localStore';
import { CHARMAP_NAMESPACE, CHARMAP_STORE_KEYS } from 'rich-text-lib/constants/charmap';
import { __HS_CHARMAP } from '../constants/plugins';
import { HS_INPAGE_SETTINGS } from '../constants/hsSettings';
import { getPortalCurrency } from 'tinymce-data/api/User';
import { addControls } from './controls';
export const HS_CHARMAP = __HS_CHARMAP;
const charmapLocalStorage = {};
export function getStoreHandlers(editor) {
  const inpage = editor.settings[HS_INPAGE_SETTINGS];
  const init = callback => {
    // Make a copy of the parent window's localStorage
    function setupStore(store) {
      Object.keys(store).forEach(key => {
        charmapLocalStorage[key] = store[key];
      });
      callback();
    }
    if (inpage) {
      // Fetch store from the parent window
      editor.settings.bus.postMessage({
        action: 'getStoreValues',
        payload: {
          storeKeys: CHARMAP_STORE_KEYS,
          storeNamespace: CHARMAP_NAMESPACE
        }
      }).then(store => {
        setupStore(store);
      });
    } else {
      const newStore = LocalStoreHandlers.getStore(window, CHARMAP_STORE_KEYS, CHARMAP_NAMESPACE);
      setupStore(newStore);
    }
  };
  const getter = key => {
    if (!charmapLocalStorage) return null;
    return charmapLocalStorage[key];
  };
  const setter = (key, value) => {
    if (!charmapLocalStorage) return;
    charmapLocalStorage[key] = value;
    if (inpage) {
      // Sync to the localStorage of the parent window
      editor.settings.bus.postMessage({
        action: 'setStoreValue',
        payload: {
          key,
          value,
          storeKeys: CHARMAP_STORE_KEYS,
          storeNamespace: CHARMAP_NAMESPACE
        }
      });
    } else {
      LocalStoreHandlers.setValue(window, CHARMAP_STORE_KEYS, CHARMAP_NAMESPACE, {
        key,
        value
      });
    }
  };
  return {
    init,
    getter,
    setter
  };
}
function charmapPlugin(editor) {
  editor.on('init', () => {
    const getCurrency = getPortalCurrency(editor.settings.apiClient);
    tinymce.canvas.addIdleCallback(editor, null, () => {
      getCurrency().then(result => {
        if (!charmapLocalStorage.currency) {
          charmapLocalStorage.currency = path(['homeCurrency', 'currencyCode'], result);
        }
      }).catch(error => console.error(error));
    });
  });
  addControls(editor, HS_CHARMAP, getStoreHandlers);
}
tinymce.PluginManager.add(HS_CHARMAP, charmapPlugin);